<template>
    <div class="system">
      <h1>{{ $i18n.t('pages.system.title') }}</h1>
      <date-time-setup></date-time-setup>
      <div>
        <v-row style="margin-top: 20px" justify="start">
          <v-col cols="12" md="4" sm="6">
            <v-card id="locale_card" class="setup-card">
              <v-card-title>
                <span class="main_card_title">{{$i18n.t('pages.system.locale_switcher.system_language')}}</span>
              </v-card-title>
              <v-card-text style="padding: 0 16px 25px 16px">
                <locale-switcher :locales="supported_locales"></locale-switcher>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <v-card id="journal_setup_card" class="setup-card">
              <v-card-title>
                <span class="main_card_title">{{ $i18n.t('pages.system.journal_settings.journal_storage_period') }}</span>
              </v-card-title>
              <v-card-text style="padding: 0 16px 25px 16px">
                <journal-setup
                />
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" sm="6" >
            <integration-setup/>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <system-manager/>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <v-card id="license_key" class="setup-card">
              <v-card-title>
                <span class="main_card_title">{{ $i18n.t('pages.system.license_key_settings.license_key') }}</span>
              </v-card-title>
              <v-card-text style="padding: 0 16px 25px 16px">
                <license-key-setup
                />
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <v-card id="device_serial" class="setup-card">
              <v-card-title>
                <span class="main_card_title">{{ $i18n.t('pages.system.device_serial_settings.device_serial') }}</span>
              </v-card-title>
              <v-card-text style="padding: 0 16px 25px 16px">
                <device-serial-setup
                />
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <v-card id="devices_network" class="setup-card">
              <v-card-title>
                <span class="main_card_title">{{ $i18n.t('pages.system.devices_network_settings.devices_network') }}</span>
              </v-card-title>
              <v-card-text style="padding: 0 16px 25px 16px">
                <devices-network-setup
                />
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <CommonSettings/>
          </v-col>
        </v-row>

      </div>
    </div>
</template>

<script>
import DateTimeSetup from "../components/DateTimeSetup";
import LocaleSwitcher from "@/components/LocaleSwitcher";
import JournalSetup from "@/components/JournalSetup";
import SystemManager from "@/components/SystemManager";
import IntegrationSetup from "@/components/IntergrationSetup";
import LicenseKeySetup from "@/components/LicenseKeySetup";
import {getSupportedLocales} from "@/utils/supported-locales";
import {common_funcs} from "@/mixins/common";
import {mapActions} from "vuex";
import DeviceSerialSetup from "@/components/DeviceSerialSetup";
import DevicesNetworkSetup from "../components/DevicesNetworkSetup";
import CommonSettings from "../components/CommonSettings";

export default {
  name: "SystemPage",
  mixins: [common_funcs],
  components: {
    CommonSettings,
    DevicesNetworkSetup,
    DeviceSerialSetup,
    LicenseKeySetup,
    IntegrationSetup,
    SystemManager,
    JournalSetup,
    LocaleSwitcher,
    DateTimeSetup
  },
  data: function () {
    // this.fetch_data()
    return {
      system_params: {
        journal_data_storage_period: '',
        service_connection_url: '',
        library_license_key: '',
      }
    }
  },
  methods: {
    ...mapActions(['updateSystemParams'])
  },
  computed: {
    supported_locales: function () {
      return getSupportedLocales()
    }
  }
}
</script>

<style scoped>
.setup-card {
  background: #FFFFFF;
  box-shadow: 0 3px 2px rgba(138, 138, 138, 0.15) !important;
  border-radius: 8px;
  elevation: 0;
}
</style>